export const cleanUpCRMTables = () => ({
  type: 'CLEAN_UP_CRM_TABLES' as const,
})

export const cleanUpTableFields = () => ({
  type: 'CLEAN_UP_TABLE_FIELDS' as const,
})
